import { render, staticRenderFns } from "./ImportQuota.vue?vue&type=template&id=e057f124&scoped=true"
import script from "./ImportQuota.vue?vue&type=script&lang=js"
export * from "./ImportQuota.vue?vue&type=script&lang=js"
import style0 from "./ImportQuota.vue?vue&type=style&index=0&id=e057f124&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e057f124",
  null
  
)

export default component.exports